import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ClientLinkLayout from '@/components/ClientLinkLayout/ClientLinkLayoutContainer';
import ClientFormLink from '@/components/ClientsPublicPage/ClientFormLink';
import ClientSuccess from '@/components/ClientsPublicPage/ClientSuccess';
import Toast from '@/components/common/Toast';

const ClientsPublicPage = () => (
  <ClientLinkLayout>
    <Routes>
      <Route path="success" element={<ClientSuccess />} />
      <Route path="" element={<ClientFormLink />} />
    </Routes>

    <Toast />
  </ClientLinkLayout>
);

export default ClientsPublicPage;
